import { render, staticRenderFns } from "./NolaNovel.vue?vue&type=template&id=ccc5681c&scoped=true"
import script from "./NolaNovel.vue?vue&type=script&lang=ts"
export * from "./NolaNovel.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovel.vue?vue&type=style&index=0&id=ccc5681c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc5681c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccc5681c')) {
      api.createRecord('ccc5681c', component.options)
    } else {
      api.reload('ccc5681c', component.options)
    }
    module.hot.accept("./NolaNovel.vue?vue&type=template&id=ccc5681c&scoped=true", function () {
      api.rerender('ccc5681c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/NolaNovel.vue"
export default component.exports